<template>
    <div class="modal fade" id="new_slider" tabindex="-1">
        <div class="modal-dialog" style="margin-left: 10vw">
            <div class="modal-content" style="width: 80vw">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $lang('Utwórz nową reklamę') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="clearData">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <div class="form-group">
                            <label for="newImage">
                                {{ $lang('Zdjęcie:') }}
                                <span class="text-red">{{ $lang('(wymagane)') }}</span>
                            </label>
                            <v-select :options="images" label="name" v-model="img" id="newImage">
                                <template slot="option" slot-scope="option">
                                    <img :src="option.path" style="height: 50px"/>
                                    {{ option.name }}
                                </template>
                            </v-select>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="newHeader">{{ $lang('Nagłówek:') }}</label>
                                <input id="newHeader" class="form-control" v-model="header"
                                ></input>
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="newFooter">{{ $lang('Stopka:') }}</label>
                                <input id="newFooter" class="form-control" v-model="footer"
                                ></input>
                            </div>

                        </div>

                        <div class="form-group">
                            <label for="newDescription">{{ $lang('Treść:') }}</label>
                            <textarea id="newDescription" class="form-control" v-model="description"></textarea>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-12 col-md-6">
                                <label for="newButton">{{ $lang('Treść przycisku:') }}</label>
                                <input id="newButton" class="form-control" v-model="button"
                                ></input>
                            </div>

                            <div class="form-group col-12 col-md-6">
                                <label for="newUrl">{{ $lang('Link:') }}</label>
                                <input id="newUrl" class="form-control" v-model="url"
                                ></input>
                            </div>
                        </div>
                        <div class="form-group">
                            <label>{{ $lang('Widoczność:') }}</label>
                            <div class="form-check pl-0">
                                <input type="radio" id="active" name="activity" value="1"
                                       v-model="activity"></input>
                                <label for="active">{{ $lang('Tak') }}</label>
                                <input class="ml-2" type="radio" id="inactive" name="activity" value="0"
                                       v-model="activity"></input>
                                <label for="inactive">{{ $lang('Nie') }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal" id="close"
                            v-on:click="clearData">
                        {{ $lang('Zamknij') }}
                    </button>
                    <button @click="create" type="button" class="btn btn-primary" :disabled="valid || submitting">
                        {{ $lang('Utwórz') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
    components: {vSelect},
    name: "new-slider-modal",
    props: {
        create_url: String,
        images: Array
    },
    data() {
        return {
            header: '',
            description: '',
            footer: '',
            button: '',
            url: '',
            img: null,
            activity: 1,
            submitting: false,
        }
    },
    methods: {
        clearData: function () {
            this.header = '';
            this.description = '';
            this.footer = '';
            this.button = '';
            this.url = '';
            this.img = null;
            this.activity = 1;
            this.submitting = false;
        },
        create: function () {
            let self = this;
            self.submitting = true;
            axios.post(this.create_url, {
                header: this.header,
                description: this.description,
                footer: this.footer,
                button: this.button,
                url: this.url,
                img: this.img.path,
                activity: this.activity
            })
                .then(function () {
                    location.reload();
                    $("#close").click()
                })
                .catch(function (error) {
                    console.log(error);
                    self.submitting = false;
                });
        }
    },
    computed: {
        valid() {
            return !(this.img !== null)
        }
    }
}
</script>
